import { Destroyer } from '@adaptiva/core/common';
import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { IPanel, IPanelReference } from '../../interfaces';

@Injectable({
	providedIn: 'root'
})
export class PanelService extends Destroyer {

	private readonly _panels: WritableSignal<IPanel[]> = signal([]);

	public readonly panels: Signal<IPanel[]> = this._panels.asReadonly();

	public add<T>(_panel: IPanel): IPanelReference<T> {
		this._panels.update((_panels: IPanel[]) => {
			return [..._panels, _panel];
		});

		return {
			..._panel,
			remove: () => this.remove(_panel)
		};
	}

	public remove(_panel: IPanel): void {
		this._panels.update((_panels: IPanel[]) => _panels.filter(p => p !== _panel));
	}

}
